export default __webpack_public_path__ + "static/media/epi-welder.617e3b60.jpg";